import {
  ADD_PERMISSION,
  DELETE_PERMISSION,
  RELATION_TO_DEBTOR_OPTIONS,
  WRITE_PERMISSION,
} from "@/Constant";
import { isNumeric } from "./validation";
import { CaseTimeZoneType } from "@/pages/CaseDetail/Configuration/CaseTimeZones/caseTimeZoneType";
import { dateFunc } from "@/components/Functions/dateFunc";
import { useTranslation } from "react-i18next";
import { AttributeType } from "@/pages/CaseDetail/Configuration/Attributes/type";

export const NumberInMoneyFormat = (amount: number) => {
  if (amount === null || amount === undefined) {
    return "-";
  }
  if (!isNumeric(String(amount))) {
    return amount;
  }
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  const fomattedAMount = formatter.format(amount);
  return fomattedAMount.replace("$", "");
};
export function handleNumberTypeAttributes(attributeDetails: any) {
  let attributeKeyNames: any = {
    7: "amount",
    2: "numberValue",
  };
  let attributeValue = { ...attributeDetails };

  attributeValue[attributeKeyNames[attributeValue.attributeType]] =
    attributeDetails[attributeKeyNames[attributeValue.attributeType]]
      ? Number(
          attributeDetails[attributeKeyNames[attributeValue.attributeType]]
        )
      : null;

  return attributeValue;
}
export function handleDateTypeAttributes(attributeDetails: any) {
  let attributeKeyNames: any = {
    7: "amount",
    2: "numberValue",
    4: "dateValue",
  };
  let attributeValue = { ...attributeDetails };

  attributeValue[attributeKeyNames[attributeValue.attributeType]] =
    attributeDetails[attributeKeyNames[attributeValue.attributeType]]
      ? getOnlyDate(
            `${attributeDetails[attributeKeyNames[attributeValue.attributeType]]} `
        )
      : null;

  return attributeValue;
}
export function handleAttributeData(attributeArray: any[]) {
  let attributeValues: any = [];
  attributeArray?.forEach((value: any) => {
    if (value.value.attributeType !== AttributeType.Document) {
      if (
        [AttributeType.Currency, AttributeType.Number]?.includes(
          value.value.attributeType
        )
      ) {
        attributeValues.push(handleNumberTypeAttributes(value.value));
      } else if ([AttributeType.Date]?.includes(value.value.attributeType)) {
        attributeValues.push(handleDateTypeAttributes(value.value));
      } else {
        attributeValues.push(value.value);
      }
    }
  });
  return attributeValues;
}
export const getGovernmentType = (type: any) => {
  const documnetTypeList: any = {
    1: "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.provincialID",
    2: "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.healthCardNumber",
    3: "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.driversLicense",
    4: "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.passport",
    5: "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.stateID",
    6: "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.militaryID",
    7: "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.socialSecurityNumber",
    8: "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.socialInsuranceNumber",
    9: "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.permanentResidentNumber",
    10: "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.voterID",
    11: "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.other",
  };
  return documnetTypeList?.[type] || "-";
};

export const getTaskTypeName = (keyName: string | number) => {
  const pickListDetails: any = {
    "0": "pages.claims.taskTab.formLabels.typeOptionsLabel.readyforReview",

    "1": "pages.claims.taskTab.formLabels.typeOptionsLabel.needsFollowUp",

    "2": "pages.claims.taskTab.formLabels.typeOptionsLabel.creditorRequestedResponse",

    "3": "pages.claims.taskTab.formLabels.typeOptionsLabel.contactInfoRequiresUpdate",

    "4": "pages.claims.taskTab.formLabels.typeOptionsLabel.discussWithDebtor",

    "5": "pages.claims.taskTab.formLabels.typeOptionsLabel.discussWithCounsel",

    "6": "pages.claims.taskTab.formLabels.typeOptionsLabel.other",
  };
  return pickListDetails?.[keyName] || "-";
};
export const useGetGovernmentTypeList = () => {
  const { t } = useTranslation();

  return [
    {
      label: t("global.globalActions.optionDefault"),
      value: "",
    },
    {
      value: 1,
      label: t(
        "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.provincialID"
      ),
    },
    {
      value: 2,
      label: t(
        "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.healthCardNumber"
      ),
    },
    {
      value: 3,
      label: t(
        "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.driversLicense"
      ),
    },
    {
      value: 4,
      label: t(
        "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.passport"
      ),
    },
    {
      value: 5,
      label: t(
        "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.stateID"
      ),
    },
    {
      value: 6,
      label: t(
        "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.militaryID"
      ),
    },
    {
      value: 7,
      label: t(
        "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.socialSecurityNumber"
      ),
    },
    {
      value: 8,
      label: t(
        "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.socialInsuranceNumber"
      ),
    },
    {
      value: 9,
      label: t(
        "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.permanentResidentNumber"
      ),
    },
    {
      value: 10,
      label: t(
        "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.voterID"
      ),
    },
    {
      value: 11,
      label: t(
        "pages.creditors.creditorForm.formLabelDetails.governmentTypeLabels.other"
      ),
    },
  ];
};
export const useGetTaskTypeList = () => {
  const { t } = useTranslation();
  return [
    {
      label: t(
        "pages.claims.taskTab.formLabels.typeOptionsLabel.readyforReview"
      ),
      value: "0",
    },
    {
      label: t(
        "pages.claims.taskTab.formLabels.typeOptionsLabel.needsFollowUp"
      ),
      value: "1",
    },
    {
      label: t(
        "pages.claims.taskTab.formLabels.typeOptionsLabel.creditorRequestedResponse"
      ),
      value: "2",
    },
    {
      label: t(
        "pages.claims.taskTab.formLabels.typeOptionsLabel.contactInfoRequiresUpdate"
      ),
      value: "3",
    },
    {
      label: t(
        "pages.claims.taskTab.formLabels.typeOptionsLabel.discussWithDebtor"
      ),
      value: "4",
    },
    {
      label: t(
        "pages.claims.taskTab.formLabels.typeOptionsLabel.discussWithCounsel"
      ),
      value: "5",
    },
    {
      label: t("pages.claims.taskTab.formLabels.typeOptionsLabel.other"),
      value: "6",
    },
  ];
};

export const NonEmptyString = (value: string | undefined) => {
  return value !== "" && value !== null && value !== undefined;
};

export const isEmpty = (value: string | undefined) => {
  return value === "" || value === null || value === undefined;
};

export const formattedDate = (date: string) => {
  const now = new Date(date);
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0");
  const day = now.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getOnlyDate = (date: string | Date) => {
  const now = new Date(date);
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0");
  const day = now.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getRelationshipToDebtor = (relationshipToDebtor: number) => {
  return RELATION_TO_DEBTOR_OPTIONS[relationshipToDebtor];
};

function capitalizeFirstLetter(string: any) {
  return (
    string.charAt(0).toUpperCase() +
    string
      .slice(1)
      .replace(/([A-Z])/g, " $1")
      .trim()
      .toLowerCase()
  );
}

export const capitalizeAllWordsFirstChar = (phrase: string) => {
  return phrase
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export function capitalizeWordsInSentence(sentence: any) {
  return sentence
    .split(",")
    .map((word: any) => {
      return word.trim();
    })
    .map(capitalizeFirstLetter)
    .join(", ");
}

export function getNumbersAndDecimals(n: string | number) {
  if (n === null || n === undefined || n === "") {
    return 0;
  }
  var decPart = (n + "").split(".")[1];
  return decPart?.length || 0;
}

export const checkAmountDecimalError = (
  value: string,
  decimalLimit: number
) => {
  if (!isNumeric(value)) return true;
  const n = (value + "").split(".");
  if (n.length > 1 && n[1]?.length === 0) {
    return false;
  }
  if (decimalLimit === undefined || decimalLimit === 0) return false;
  let regex = new RegExp("^[0-9-]+(.[0-9]{1," + decimalLimit + "})?$");
  return !!(value && !regex.test(value));
};
export const checkIntegerError = (value: string) => {
  if (!isNumeric(value)) return true;
  //let regex = new RegExp('^[0-9]$');
  const n = (value + "").split(".");
  return n.length > 1;
};

export const trimString = (value: string) => {
  return value.trim();
};

export const ltrimString = (value: string) => {
  return value.trimStart();
};

export function objectTrim(obj: {}) {
  const newObject = {};
  Object.keys(obj).forEach((key) => {
    // @ts-ignore
    newObject[key] = trimString(obj[key]);
  });
  return newObject;
}

//   console.log(objectMap(myObject, mapFn)); // { a: 4, b: 8, c: 12 }

export function convertDateTimeinDate(getDate: any) {
  const date = new Date(getDate);

  // Define an array of month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract the parts of the date
  const day = date.getDate().toString().padStart(2, "0");
  const month = monthNames[date.getMonth()]; // getMonth() returns 0-11
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  // Combine the parts into the desired format "Dec 08, 2024 hh:mm:ss"
  return `${month} ${day}, ${year} ${hours}:${minutes}:${seconds}`;
}

const ZERO_HOURS = 0;
const ZERO_MINUTES = 0;
const ZERO_SECONDS = 0;
const ZERO_MILLISECONDS = 0;

/**
 * Checks if the provided date string is a past date.
 *
 * @param value - The date string to check.
 * @returns boolean - True if the date is in the past, otherwise false.
 */
export function isPastDate(value: string): boolean {
  const selectedDate = new Date(value);
  const today = new Date();
  today.setHours(ZERO_HOURS, ZERO_MINUTES, ZERO_SECONDS, ZERO_MILLISECONDS);
  return selectedDate < today;
}

/**
 * Handles the date validation and sets appropriate error messages and input values.
 *
 * @param value - The input date string.
 * @param setErrorMessage - Function to set the error message.
 * @param setInputValues - Function to set the input values.
 * @param inputValues - The current input values.
 */
export function handleDateError(
  value: string,
  setErrorMessage: (msg: string) => void,
  setInputValues: (values: any) => void,
  inputValues: any
) {
  if (isPastDate(value)) {
    setErrorMessage("You can't use a past date as a deadline");
  } else {
    setErrorMessage("");
    // @ts-ignore
    setInputValues({ ...inputValues, timeLimitDate: value.toISOString() });
  }
}

export function formatDateToDDMMYYYY(dateStr: any): string {
  if (dateStr === null || dateStr === undefined) return "-";

  // Define month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Split the input date string by "-"
  const parts = dateStr.split("-");

  // Check if the input has three parts
  if (parts.length !== 3) {
    return "";
  }

  // Parse day, month, and year
  const day = parts[0];
  const monthIndex = parseInt(parts[1], 10) - 1; // Convert to 0-indexed month
  const year = parseInt(parts[2], 10);

  // Check for valid day and month
  if (isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11 || isNaN(year)) {
    return "";
  }

  // Convert year to full year format
  const fullYear = year < 100 ? year + 2000 : year;

  // Return the formatted date as DD-MMM-YYYY
  return `${day}-${monthNames[monthIndex]}-${fullYear}`;
}
export function formatDateToDDMMYYYYWithOutHyphen(dateStr: any): string {
  if (dateStr === null || dateStr === undefined) return "-";

  // // Define month names
  // const monthNames = [
  //   "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  //   "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  // ];

  // Split the input date string by "-"
  const parts = dateStr.split("-");

  // Check if the input has three parts
  if (parts.length !== 3) {
    return "";
  }

  // Parse day, month, and year
  const day = parts[0];
  const monthIndex = parseInt(parts[1], 10) - 1; // Convert to 0-indexed month
  const year = parseInt(parts[2], 10);

  // Check for valid day and month
  if (isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11 || isNaN(year)) {
    return "";
  }

  // Convert year to full year format
  const fullYear = year < 100 ? year + 2000 : year;

  // Return the formatted date as DDMMMYYYY
  return `${day}${(monthIndex + 1).toString().padStart(2, "0")}${fullYear}`;
}

export function commonFormateName(
  caseShortName: string,
  entityName: string,
  caseZone: string | undefined,
  entityType?: string
) {
  let fileName = "";
  if (entityType) {
    fileName = `${caseShortName}_${entityName}_${entityType}_${
      dateFunc(new Date(), caseZone).formattedDateTimeWithOutHyphen
    } ${caseZone}`;
  } else {
    fileName = `${caseShortName?.replace(/\./g, "_")}_${entityName}_${
      dateFunc(new Date(), caseZone).formattedDateTimeWithOutHyphen
    } ${caseZone}`;
  }
  return fileName?.replace(/\./g, "_");
}

const convertToCommaSeparatedNumber = (
  amountWithDecimalPlace: any,
  decimalPlace: number
) => {
  let [integerPart, decimalPart] = amountWithDecimalPlace.toString().split(".");
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  if (decimalPlace > 0) {
    return `${integerPart}.${decimalPart}`;
  } else {
    return integerPart;
  }
};
export const convertToCommaSeparatedNumberwithoutDecimal = (amount: any) => {
  if (amount === null || amount === undefined) return "-";
  let [integerPart, decimalPart] = amount.toString().split(".");
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decimalPart ? `${integerPart}.${decimalPart}` : `${integerPart}`;
};
// Function to format the amount with the corresponding UNIT's decimal place
export const formatAmountUnitDecimalPlace = (
  amount: number | null | undefined,
  decimalPlace: number
) => {
  if (amount === null || amount === undefined) return "-";
  const amountWithDecimalPlace = amount.toFixed(decimalPlace);
  return convertToCommaSeparatedNumber(amountWithDecimalPlace, decimalPlace);
};

export const amountUnitDecimalPlace = (
  amount: number | null | undefined,
  decimalPlace: number
) => {
  if (amount === null || amount === undefined) return "-";
  return amount.toFixed(decimalPlace);
};

export const getStatusDescription = (status: number) => {
  switch (status) {
    case 1:
      return "Unlocked";
    case 2:
      return "Locked";
    case 3:
      return "Committed";
    default:
      return "Unknown";
  }
};

export const formatAmountWithCommas = (
  amount: number | null | undefined,
  decimalPlace: number
) => {
  if (amount === null || amount === undefined) return "";
  let numericAmount: any = Number(amount);
  if (isNaN(numericAmount)) return "";

  numericAmount = numericAmount.toFixed(decimalPlace);
  return convertToCommaSeparatedNumber(numericAmount, decimalPlace);
};

export const customComparator = (valueA: string, valueB: string) => {
  valueA = String(valueA);
  valueB = String(valueB);
  return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
};
// export const customDateComparator = (valueA: string, valueB: string) => {
//   let date1 = new Date(valueA);
//   let date2 = String(valueB);
//   return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
// };

export function customDateComparator(valueA: string, valueB: string) {
  var date1Number: any = valueA && new Date(valueA).getTime();
  var date2Number: any = valueB && new Date(valueB).getTime();
  if (date1Number == null && date2Number == null) {
    return 0;
  }

  if (date1Number == null) {
    return -1;
  } else if (date2Number == null) {
    return 1;
  }

  return date1Number - date2Number;
}

export const processTreeRows = (
  treeRows: any[],
  caseId: string | undefined
): any => {
  const rules: any = [];
  const groups: any = [];
  treeRows.forEach((row: any) => {
    if (row.type === "group") {
      const processedGroup = {
        CaseId: caseId,
        rules: row.treeRows
          .filter((rule: any) => rule.type === "row")
          .map((rule: { type: string; [key: string]: any }) => {
            const { type, ...rest } = rule;
            return rest;
          }),
        groups: null,
        logicalOperator: parseInt(row.logicalOperator),
        pageNumber: 1,
        pageSize: 1000,
      };
      groups.push(processedGroup);
    } else {
      const { type, ...rest } = row;
      rules.push(rest);
    }
  });
  return { rules, groups };
};
export const getPaymentStatus = (status: number) => {
  switch (status) {
    case 0:
      return "Draft";
    case 1:
      return "Issued";
    case 2:
      return "Cashed";
    case 3:
      return "Replaced";
    case 4:
      return "Stop";
    case 5:
      return "Undelivered";
    case 6:
      return "Void";
    default:
      return "-";
  }
};
export const getPaymentPrefix = (prefix: number) => {
  switch (prefix) {
    case 0:
      return "Cheque";
    case 1:
      return "Statement";
    case 2:
      return "Wire";
    case 3:
      return "Other";
    default:
      return "-";
  }
};

export const getRoleName = (roleId: number) => {
  switch (roleId) {
    case 0:
      return "pages.userManagementPage.basicUser";
    case 1:
      return "pages.userManagementPage.caseCreator";
    case 2:
      return "pages.userManagementPage.systemAdmin";
    default:
      return "Unknown Role";
  }
};
export const getTimezones = (data: CaseTimeZoneType[], defaultOpt?: any[]) => {
  let timeZonesOptions = defaultOpt
    ? defaultOpt
    : [{ label: "Please Select", value: "" }];
  if (!data || data === undefined) return timeZonesOptions;
  const options = data.map((timeZone: CaseTimeZoneType) => {
    return { label: timeZone.timeZoneName, value: timeZone.timeZoneId };
  });
  return [...timeZonesOptions, ...options];
};

//this function removes unwanted null instead of empty string
export const cleanPayload = (payload: any) => {
  const cleanedPayload: any = {};
  for (const key in payload) {
    if (payload[key] === null) {
      cleanedPayload[key] = "";
    } else {
      cleanedPayload[key] = payload[key];
    }
  }
  return cleanedPayload;
};

export const havingEditPermission = (permissions: string[]) => {
  return (
    permissions &&
    permissions.length > 0 &&
    permissions?.includes(WRITE_PERMISSION)
  );
};

export const havingDeletePermission = (permissions: string[]) => {
  return (
    permissions &&
    permissions.length > 0 &&
    permissions?.includes(DELETE_PERMISSION)
  );
};

export const havingAddPermission = (permissions: string[]) => {
  return (
    permissions &&
    permissions.length > 0 &&
    permissions?.includes(ADD_PERMISSION)
  );
};

export function isEmptyObject(obj: any) {
  return Object.keys(obj).length === 0;
}

export function isCountryCanadaOrUS(name: string) {
  return name === "CANADA" || name === "UNITED STATES OF AMERICA";
}
